"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.ProductCancellationInsuranceCreateDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var _1 = require(".");
var ProductCancellationInsuranceCreateDto = (function (_super) {
    __extends(ProductCancellationInsuranceCreateDto, _super);
    function ProductCancellationInsuranceCreateDto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productCategory = 'CANCELLATION_INSURANCE';
        return _this;
    }
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsIn(['CANCELLATION_INSURANCE']),
        __metadata("design:type", String)
    ], ProductCancellationInsuranceCreateDto.prototype, "type");
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsIn(['CANCELLATION_INSURANCE']),
        __metadata("design:type", Object)
    ], ProductCancellationInsuranceCreateDto.prototype, "productCategory");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ProductCancellationInsuranceCreateDto.prototype, "insuranceId");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return _1.ProductPriceDto; }),
        __metadata("design:type", _1.ProductPriceDto)
    ], ProductCancellationInsuranceCreateDto.prototype, "price");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ProductCancellationInsuranceCreateDto.prototype, "market");
    return ProductCancellationInsuranceCreateDto;
}(_1.ProductDto));
exports.ProductCancellationInsuranceCreateDto = ProductCancellationInsuranceCreateDto;
//# sourceMappingURL=product-cancellation-insurance-create.dto.js.map